import { useMutation, useQueryClient } from "@tanstack/react-query";
import { type EnvName } from "./api";
import { notifyBoardSync, refreshBoard } from "./useBoardEvents";
import { useApi } from "./useApi";
import { useVoiceSession } from "./VoiceSessionContext";

export function BoardResetButton({
  env,
  compact = false,
}: {
  env: EnvName;
  compact?: boolean;
}) {
  if (env !== "sim") return null;

  const api = useApi(env);
  const queryClient = useQueryClient();
  const { newShift } = useVoiceSession();
  const reset = useMutation({
    mutationFn: api.resetBoard,
    onSuccess: () => {
      newShift();
      notifyBoardSync(env);
      refreshBoard(queryClient, env, { includeAdvisory: true });
    },
  });

  return (
    <button
      type="button"
      className={compact ? "btn btn--secondary board-reset-btn" : "btn btn--secondary"}
      onClick={() => reset.mutate()}
      disabled={reset.isPending}
      title="Reset entire sim board — all sections cleared, no conflicts"
    >
      {reset.isPending ? "Resetting…" : compact ? "Reset all" : "Reset all"}
    </button>
  );
}
